/* eslint-disable */

import moment from 'moment';
import React, { memo, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Input } from 'reactstrap';
import {
  boxConfig,
  getEpikBoxesSerial,
  getLteAnalyzer,
  getSimCheckUtilities,
  runSimCheck,
  SetSelectedBoxes,
  swapBoxObi,
  getEngineeringLock as getEngineeringLockAction,
  addEngineeringLock,
  deleteEngineeringLock,
  updateEpikBox,
  getEpikBoxData,
  sendBoxTone,
  enhancedRouting,
  enableDisableEpikUpdates,
  fetchEpikUpdatesStatus,
  addNote,
} from '../../../../../actions/EpikBoxes';
import { TOOLTIPS_TEXT } from '../../../../../lib/constants';
import utils from '../../../../../lib/utils';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import ConfirmationModal from '../../../../ConfirmationModal';
import DeviceLockRequiredModal from '../../DeviceLockRequiredModal';
import InfoPopup from '../../../../InfoPopup';
import SpinnerCircles from '../../../../Spinner/SpinerCircles';
import Spinner from '../../../../Spinner/Spinner';
import Toggle from '../../../../Toggle';
import WarningModal from '../../../../WarningModal';
import DynamicAutoComplete from '../../../DynamicAutoComplete';
import './AdminTools.css';
import { ResetBoxToDefault } from './components';
import ModemRow from './components/ModemRow';
import SimInformation from './components/SimInformation';
import { useFetchSimStatus, useMemoizedSims } from './hooks';
import { AdminFlags } from './components/AdminFlags';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';
import ExpansionModuleAdminTools from './components/ExpansionModuleAdminTools';
import { publishDeviceSwapStatus } from '../../../../../lib/deviceSwapSync';

const WARNING =
  'This utility will cause temporary disruption of service while the carrier services are checked. Are you sure you want to proceed?';
const INITIAL_CONFIRMATION_STATE = {
  visible: false,
  bodyText: '',
};

const AdminTools = memo(() => {
  var token = localStorage.getItem('jwtToken');
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });

  const simCheck = useSelector(state => state.AppState.boxDetails.simCheck);
  const user = useSelector(state => state.AppState.user);
  const box = useSelector(state => state.AppState.boxDetails.box);

  const [confirmation, setConfirmation] = useState(INITIAL_CONFIRMATION_STATE);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [demoConfirm, setDemoConfirm] = useState(false);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const [serialBoxes, setSerialBoxes] = useState([]);
  const [selectedBox, setSelectedBox] = useState('');
  const [lockModal, setLockModal] = useState(false);
  const [warningStatus, setWarningStatus] = useState(false);
  const [lock, setLock] = useState();
  const [disableEpikUpdateBtn, setDisableEpikUpdateBtn] = useState({
    disableEpikUpdateCheck: false,
    isSecurityModalVisible: false,
  });

  const [toneLoading, setToneLoading] = useState(false);
  const [deviceSwapLoading, setDeviceSwapLoading] = useState(false);
  const [proceedLoading, setProceedLoading] = useState(false);
  const [transferNotes, setTransferNotes] = useState(true);
  const [enhancedRoutingEnabled, setEnhancedRoutingEnabled] = useState(false);
  const [epikUpdates, setEpikUpdates] = useState(box?.epikUpdateStatus);
  const [epikLabBoxLoading, setEpikLabBoxLoading] = useState(false)

  const engineeringLock = getPermissionForComponent('engineeringLock',user.permissionsGroup);
  const epikUpdatesPermission = getPermissionForComponent('epikUpdates',user.permissionsGroup);
  const demoBoxPermission = getPermissionForComponent('demoBox',user.permissionsGroup);
  const isExpansionModule = box?.serialNumber?.startsWith('E-');
  const canViewDemoBox =
    user?.role === 'superAdmin' ||
    demoBoxPermission === 'read' ||
    demoBoxPermission === 'write' ||
    demoBoxPermission === 'both';

  const canEditDemoBox =
    user?.role === 'superAdmin' ||
    demoBoxPermission === 'write' ||
    demoBoxPermission === 'both';

  const { loading: resetBoxLoading } = useSelector(
    state => state.UIState.epikBoxes.resetBoxToDefault,
  );

  // useState for setBoxConfig
  const [boxConfigStatus, setBoxConfigStatus] = useState('');
  const onSimCheck = async () => {
    setConfirmation(INITIAL_CONFIRMATION_STATE);
    const { _id, vpnAddress } = box;
    setLoading(true);
    await dispatch(runSimCheck(token, _id, vpnAddress));
    setLoading(false);
  };
  useEffect(() => {
    const fetchBoxesSerial = async () => {
      const { assignedTo } = box;
      const boxesSerialList = await dispatch(getEpikBoxesSerial(token, assignedTo?._id, 'yes', isExpansionModule));
      setSerialBoxes(boxesSerialList);
    };
    fetchBoxesSerial();
  }, []);

  useEffect(() => {
    async function fetchEpikUpdates() {
      const resp = await dispatch(fetchEpikUpdatesStatus(token, box?._id));
      setEpikUpdates(resp)
    }
    if (!isExpansionModule) fetchEpikUpdates();
  }, []);

  const modemSim2 = modems => {
    if (modems?.length === 1) {
      return modems[0].sims[1];
    } else if (modems?.length === 2) {
      return modems[1].sims[1];
    }
  };
  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }

  };
  const onFetch = async () => {
    const { _id, vpnAddress } = box;
    setLoadingFetch(true);
    await dispatch(getSimCheckUtilities(token, _id, vpnAddress));
    await dispatch(getEpikBoxData(token, _id));
    setLoadingFetch(false);
  };
  const getSimPingableColor = val => {
    // eslint-disable-next-line eqeqeq
    if (val == 'true') return 'green';
    else return 'red';
  };
  const onOptionsChange = async e => {
    setSelectedBox(e);
  };
  const removeValueFromArray = (array, value) => {
    const index = array.indexOf(value);
    if (index !== -1) {
      array.splice(index, 1);
    }
    return array;
  };

  const onDemoBoxToggle = async () => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
    } else {
      setDemoConfirm(true);
    }

  };

  const onEpikLabBoxToggle = async () => {
    const { _id, epikLabBox } = box;
    const updatedBox = { ...box, epikLabBox: !epikLabBox };
    setEpikLabBoxLoading(true)
    await dispatch(updateEpikBox(token, updatedBox));
    await dispatch(getEpikBoxData(token, _id));
    setEpikLabBoxLoading(false)
  };

  const onDemoConfirm = async () => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
      return;
    }
    const { _id, isDemoBox } = box;
    const updatedBox = { ...box, isDemoBox: !isDemoBox };
    await dispatch(updateEpikBox(token, updatedBox));
    await dispatch(getEpikBoxData(token, _id));
    setDemoConfirm(false);
  };

  const onExecuteBox = async () => {
    const currBox = box?.serialNumber;
    if (!selectedBox) {
      toast.error(`Please select destination box serial`);
      return;
    }
    setDeviceSwapLoading(true);
    try {
      const boxConfigResponse = await dispatch(boxConfig(token, currBox, selectedBox));
      setBoxConfigStatus(boxConfigResponse);
      if (boxConfigResponse?.dcMismatch) {
        toast.error(boxConfigResponse.message);
        return;
      }
      if (boxConfigResponse?.blankConfig) {
        setWarningStatus(true);
      }
    } finally {
      setDeviceSwapLoading(false);
    }
  };
  const onProceed = async () => {
    const currBox = box.serialNumber;
    setWarningStatus(false);
    setProceedLoading(true);
    const startedAt = new Date().toISOString();
    dispatch({
      type: 'SWAP_STATUS_UPDATE',
      swapInProgress: true,
      swapPartnerSerial: selectedBox,
      swapStartedAt: startedAt,
    });
    publishDeviceSwapStatus({
      serials: [currBox, selectedBox],
      swapInProgress: true,
      sourceSerial: currBox,
      destSerial: selectedBox,
      swapPartnerSerialBySerial: {
        [currBox]: selectedBox,
        [selectedBox]: currBox,
      },
      swapStartedAt: startedAt,
    });
    try {
      const result = await dispatch(swapBoxObi(token, currBox, selectedBox, { transferNotes }));
      dispatch({
        type: 'DEVICE_SWAP_RESULT',
        result:
          result && typeof result === 'object'
            ? result
            : {
                success: false,
                message: 'Device swap failed',
                errorResp: [],
                failedFeatures: [],
              },
      });
    } finally {
      dispatch({
        type: 'SWAP_STATUS_UPDATE',
        swapInProgress: false,
        swapPartnerSerial: null,
        swapStartedAt: null,
      });
      publishDeviceSwapStatus({
        serials: [currBox, selectedBox],
        swapInProgress: false,
        sourceSerial: currBox,
        destSerial: selectedBox,
        swapPartnerSerialBySerial: {},
        swapStartedAt: null,
      });
      setProceedLoading(false);
      if (box?._id) {
        await dispatch(getEpikBoxData(token, box._id));
      }
    }
  };
  const onShowConfirmationWarning = () => {
    setConfirmation({ visible: true, bodyText: WARNING });
  };
  const lteAnalyzerCall = async () => {
    var resp = await dispatch(getLteAnalyzer(token, box._id, box.vpnAddress));
    console.log({ resp });
  };
  const { 0: sims } = useMemoizedSims(box);
  const { activationState, fetchSimStatus } = useFetchSimStatus(sims, box);
  const { loading: simStateLoading, connection } = activationState;

  useEffect(() => {
    getEngineeringLock();
  }, []);
  const getEngineeringLock = async () => {
    let lock = await dispatch(getEngineeringLockAction(token, box._id));
    if (lock && lock.type === 'GET_ENGINEERING_LOCK_ERROR') {
      setLock(false);
      return;
    }
    setLock(Boolean(lock));
  };
  // const toggleLock = async e => {
  //   const divElement = document.getElementById('test-time-remaining');
  //   const isHidden = divElement.getAttribute('hidden') !== null;
  //   if (isHidden) {
  //     setDcUpdatePopup({ show: true });
  //   } else {


  //   if (e.target.value == 'false' || e.target.value == 'true') setLockModal(true);
  //   else if (e.target.value == 'add') {
  //     await dispatch(addEngineeringLock(token, box._id));
  //     setLockModal(false);
  //   } else {
  //     await dispatch(deleteEngineeringLock(token, box._id));
  //     setLockModal(false);
  //   }
  //   getEngineeringLock();
  // }
  // };
  const toggleLock = async (e) => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
    } else {
      if (e.target.checked) {
        await dispatch(addEngineeringLock(token, box._id));
      } else {
        await dispatch(deleteEngineeringLock(token, box._id));
      }
      await getEngineeringLock();
    }
  };


  const handleDiableEpikBtn = async e => {
    setLoading(true);
    const res = await dispatch(
      enableDisableEpikUpdates(token, box?._id, !box?.epikUpdateStatus),
    );
    if (res) {
      setEpikUpdates(!box?.epikUpdateStatus);
      const obj = {
        note: `Epik updates ${box?.epikUpdateStatus ? 'disabled' : 'enabled' } on box ${box?.serialNumber}`,
        type: 'system',
      };
      await dispatch(addNote(token, box?._id, obj));
    }
    await dispatch(getEpikBoxData(token, box?._id));
    // setDisableEpikUpdateBtn({
    //   isSecurityModalVisible: false,
    //   disableEpikUpdateCheck: false,
    // });
    setLoading(false);
  };

  const sendBoxToneHandler = async e => {
    setToneLoading(true);
    await dispatch(sendBoxTone(token, box.vpnAddress));

    setTimeout(() => {
      setToneLoading(false);
    }, 500);
  };

  const checkEnhancedRoutingEnabled = async e => {
    const boxRegistrar = box.boxRegistrar === 'Unified';
    const advancedRouting = box.advancedRouting === true;

    console.log(
      `Sim Activation Check - boxRegistrar: ${boxRegistrar} - advancedRouting: ${advancedRouting}`,
    );

    if (boxRegistrar && !advancedRouting) {
      setEnhancedRoutingEnabled(true);
    } else {
      fetchSimStatus();
    }
  };

  const onSimCheckConfirm = async e => {
    setEnhancedRoutingEnabled(false);
    setLoading(true);
    fetchSimStatus();

    if (!box.advancedRouting && !lock) {
      await dispatch(enhancedRouting(token, box?._id, 1));
      await dispatch(getEpikBoxData(token, box?._id));
    }
    setLoading(false);
  };

  // Admin tools logic for Expansion Module
  if (isExpansionModule) {
    return(
      <ExpansionModuleAdminTools 
        serialBoxes={serialBoxes}
        removeValueFromArray={removeValueFromArray}
        onOptionsChange={onOptionsChange}
        selectedBox={selectedBox}
        lockDeviceHandler={unLockBoxButton}
      />
    )
  }

  return (
    <div className="admin-tools-container">
      {loading && <Spinner />}
      <ModemRow
        simStateLoading={simStateLoading}
        fetchSimStatus={fetchSimStatus}
        onClick={checkEnhancedRoutingEnabled}
      />
      {!!connection?.length && <SimInformation sims={connection} />}
      <div className="modam-row">
        <h1 className="heading d-flex">
          SIM Failover Check
          <sup>
            <InfoPopup id="modem-utility" text={TOOLTIPS_TEXT.MODEM_CHECK_UTILITY} />
          </sup>
        </h1>
        <Button
          disabled={loading}
          onClick={ () => {
            const divElement = document.getElementById('test-time-remaining');
            const isHidden = divElement.getAttribute('hidden') !== null;
            if (isHidden) {
              setDcUpdatePopup({ show: true });
            } else {
              onShowConfirmationWarning()
            }

          }}
          color="primary"
          className="admin-tool-execute-btn"
        >
          {loading ? <SpinnerCircles /> : 'Execute'}
        </Button>
        <Button
          disabled={loading}
          onClick={onFetch}
          color="primary"
          className="admin-tool-execute-btn"
        >
          {loadingFetch ? <SpinnerCircles /> : 'Retrieve Results'}
        </Button>
      </div>
      {Array.isArray(simCheck) && simCheck.length > 0 && (
        <div className="modam">
          {simCheck.map(item => {
            var date = '';
            var timestamp = item.TIMESTAMP.split('.').shift();
            if (timestamp) {
              date = moment
                .utc(timestamp, 'YYYY-MM-DD hh:mm:ss')
                .local()
                .format('YYYY-MM-DD hh:mm:ss');
            }
            return (
              <div className='sims-information'>
                <span>
                  Carrier: <span>{item.SIMCARRIER}</span>
                </span>
                <span>{`SIM ${item?.SIMNUMBER}: ${item?.SIMICCID}`}</span>
                <span>{`IMEI: ${item.MODEMIMEI}`}</span>
                <span>{`MobileTelNum: ${item.SIMMTN}`}</span>
                <span>{`IP: ${item?.SIMIP}`}</span>
                <span>
                  Pingable:{' '}
                  <span
                    style={{
                      color: getSimPingableColor(item.SIMPINGABLE),
                    }}
                  >
                    {item.SIMPINGABLE === 'true' ? 'Yes' : 'No'}
                  </span>
                </span>
                <span>
                  TIMESTAMP: 
                  <span style={{ color: timestamp && utils.isOlderThan24Hours(timestamp) ? 'red' : undefined, fontWeight: timestamp && utils.isOlderThan24Hours(timestamp) ? 500 : undefined }}>
                    {date}
                  </span>
                </span>
              </div>
            );
          })}
        </div>
      )}
      
      {(user.role === 'superAdmin' || user.role === 'companyGroupAdmin') && <AdminFlags boxId={box?._id}/> }
      {(user.role === 'superAdmin' || user.role === 'companyGroupAdmin') && (
        <>
          <h1 className="device heading d-flex">
            Device Swap
            <sup>
              <InfoPopup id="device-swap" text={TOOLTIPS_TEXT.DEVICE_SWAP} />
            </sup>
          </h1>
          <div className="modam-row">
            <div>
              <p className="destination-text">Destination Serial</p>
              <DynamicAutoComplete
                isDisabled={!serialBoxes.length || deviceSwapLoading || proceedLoading || !!box?.swapInProgress}
                dropdownList={removeValueFromArray(serialBoxes, box.serialNumber)}
                onChange={({ suggestion }) => onOptionsChange(suggestion)}
                placeholder={serialBoxes.length ? 'Serial Number' : 'No Boxes Found'}
                onKeyDown={false}
              />
            </div>
            {!!serialBoxes.length && (
              <Button
                onClick={ () => {
                  const divElement = document.getElementById('test-time-remaining');
                  const isHidden = divElement.getAttribute('hidden') !== null;
                  if (isHidden) {
                    setDcUpdatePopup({ show: true });
                  } else {
                    onExecuteBox()
                  }

                }}
                disabled={!selectedBox || deviceSwapLoading || proceedLoading || !!box?.swapInProgress}
                color="primary"
                className="admin-tool-execute-btn"
              >
                {deviceSwapLoading || proceedLoading || box?.swapInProgress ? <SpinnerCircles /> : 'Execute'}
              </Button>
            )}
            {!boxConfigStatus.blankConfig && (
              <p className="font-weight-bold ml-3 mt-2 config-color" style={{ width: '400px' }}>{boxConfigStatus?.message}</p>
            )}
          </div>
        </>
      )}

      <div className="modam-row mt-4">
        <h1 className="heading d-flex" style={{ marginRight: '5rem' }}>
          {' '}
          Send Tone
          <sup>
            <InfoPopup id="send-tone" text={TOOLTIPS_TEXT.SEND_TONE} />
          </sup>
        </h1>
        <Button
          disabled={loading}
          // onClick={onShowConfirmationWarning}
          onClick={ () => {
            const divElement = document.getElementById('test-time-remaining');
            const isHidden = divElement.getAttribute('hidden') !== null;
            if (isHidden) {
              setDcUpdatePopup({ show: true });
            } else {
              sendBoxToneHandler()
            }

          }}
          color="primary"
          className="admin-tool-execute-btn"
        >
          {toneLoading ? <SpinnerCircles /> : 'Execute'}
        </Button>
      </div>
      {canViewDemoBox && (
      <div className="modam-row" style={{ marginTop: 15 }}>
        <h1 className="device heading d-flex" id="demo-box">
          Demo Box
          <sup>
            <InfoPopup id="enable-demo-box" text={TOOLTIPS_TEXT.DEMO_BOX} />
          </sup>
        </h1>
        <div className="pl-5">
            <Toggle value={box?.isDemoBox} id="demo-box-toggle" onToggle={canEditDemoBox ? onDemoConfirm : undefined} disabled={!canEditDemoBox} />
        </div>
      </div>
      )}
       {
       user?.epikEngineering &&
        <div className="modam-row" style={{ marginTop: 10 }}>
          <h1 className="device heading d-flex" id="epik-lab-box">
            Epik Lab Box
            <sup>
              <InfoPopup id="enable-epik-lab-box" text={TOOLTIPS_TEXT.EPIK_LAB_BOX} />
            </sup>
          </h1>
          <div className="pl-5">
            {epikLabBoxLoading ? <SpinnerCircles red/> : 
            <Toggle value={box?.epikLabBox} id="epik-lab-box-toggle" onToggle={onEpikLabBoxToggle} />
            }
          </div>
        </div>
       }

        {engineeringLock && (
          <div className="modam-row" style={{ marginTop: 30 }}>
            <h1 className="heading pr-5">Engineering Lock</h1>
            <div className="pl-5">
              {typeof lock === 'boolean' ? (
                <input
                  value={lock}
                  checked={lock}
                  type="checkbox"
                  id="engineering-lock"
                  disabled={engineeringLock === 'read'}
                  onChange={
                    (engineeringLock === 'write' || engineeringLock === 'both')
                      ? toggleLock
                      : undefined
                  }
                />
              ) : (
                'Loading...'
              )}
            </div>
          </div>
      )}
      {/* <div className="modam-row" style={{ marginTop: 10 }}>
        <h3 className="heading pr-5">EPIK Updates</h3>
        <div className="pl-5">
          <input
            onChange={() => {
              const divElement = document.getElementById('test-time-remaining');
              const isHidden = divElement.getAttribute('hidden') !== null;
              if (isHidden) {
                setDcUpdatePopup({ show: true });
              } else {
                if (!box?.epikUpdateStatus) {
                  setDisableEpikUpdateBtn({
                    ...disableEpikUpdateBtn,
                    isSecurityModalVisible: true,
                  });
                } else {
                  setDisableEpikUpdateBtn({
                    ...disableEpikUpdateBtn,
                    disableEpikUpdateCheck: true,

                  });
                }
              }
            }}
            checked={epikUpdates}
            type="checkbox"
          />
        </div>
      </div> */}
      {epikUpdatesPermission && (
        <div className="modam-row" style={{ marginTop: 10 }}>
          <h3 className="heading pr-5">EPIK Updates</h3>
          <div className="pl-5">
            <Toggle
              value={epikUpdates} 
              id="epik-updates-toggle"
              disabled={epikUpdatesPermission === 'read'}
              onToggle={() => {
                const divElement = document.getElementById('test-time-remaining');
                const isHidden = divElement?.getAttribute('hidden') !== null;
                if (isHidden) {
                  setDcUpdatePopup({ show: true });
                } else {
                  if (epikUpdates) {
                    setDisableEpikUpdateBtn({
                      ...disableEpikUpdateBtn,
                      disableEpikUpdateCheck: true,
                    });
                  } else {
                    const newEpikUpdateStatus = !epikUpdates; 
                    setEpikUpdates(newEpikUpdateStatus); 
                    handleDiableEpikBtn(newEpikUpdateStatus); 
                  }
                }
              }}
            />
          </div>
        </div>
      )}

      {/* Reset to Default */}
      <ResetBoxToDefault user ={user} box = {box} loading={resetBoxLoading} setDcUpdatePopup={setDcUpdatePopup} />

      <ConfirmationModal
        bodyText="Are you sure you want to disable the Epik Update Button?"
        isOpen={disableEpikUpdateBtn?.disableEpikUpdateCheck}
        onConfirm={() => {
          const newEpikUpdateStatus = false; 
          setEpikUpdates(newEpikUpdateStatus); 
          handleDiableEpikBtn(newEpikUpdateStatus);
          setDisableEpikUpdateBtn({
            ...disableEpikUpdateBtn,
            disableEpikUpdateCheck: false, 
          });
        }}
        onCancel={() => {
          setDisableEpikUpdateBtn({
            ...disableEpikUpdateBtn,
            disableEpikUpdateCheck: false, 
          });
        }}
      />

      <AddSecurityCodeModal
        isOpen={lockModal}
        onConfirm={() => toggleLock({ target: { value: !lock ? 'add' : 'remove' } })}
        onCancel={() => setLockModal(false)}
        engineeringCode={true}
        featureName={'engineeringLock'}
      />
      <AddSecurityCodeModal
        isOpen={demoConfirm}
        onConfirm={onDemoConfirm}
        onCancel={() => setDemoConfirm(false)}
        demoCode
        featureName={'demoCode'}
      />
      <AddSecurityCodeModal
        isOpen={disableEpikUpdateBtn?.isSecurityModalVisible}
        onConfirm={handleDiableEpikBtn}
        onCancel={() =>
          setDisableEpikUpdateBtn({
            disableEpikUpdateCheck: false,
            isSecurityModalVisible: false,
          })
        }
        epikUpdateBtnDisable
        featureName={'epikUpdateBtnDisable'}
      />
      <ConfirmationModal
        isOpen={warningStatus}
        onCancel={() => {
          setWarningStatus(false);
        }}
        // eslint-disable-next-line max-len
        bodyText="This action will migrate all port configurations, options, networking, OOBM, and port features to the new destination device and return this device to factory settings. Integration will be triggered on the destination device. Are you sure you want to proceed?"
        onConfirm={onProceed}
        loading={proceedLoading}
        extraContent={
          <label className="swap-transfer-notes" htmlFor="transfer-notes-checkbox">
            <input
              id="transfer-notes-checkbox"
              type="checkbox"
              checked={transferNotes}
              onChange={e => setTransferNotes(e.target.checked)}
            />
            Transfer all notes to the destination device
          </label>
        }
      />
      <DeviceLockRequiredModal
        isOpen={dcUpdatePopup.show}
        onCancel={() => {
          setDcUpdatePopup({ show: false, value: {} });
        }}
        onConfirm={() => {
          unLockBoxButton();
          setDcUpdatePopup({ show: false, value: {} });
        }}
      />
      <WarningModal
        isOpen={enhancedRoutingEnabled}
        onCancel={() => {
          fetchSimStatus();
          setEnhancedRoutingEnabled(false);
        }}
        onConfirm={onSimCheckConfirm}
        body="This device is currently registered to the “Unified” Servers and needs to be migrated to “Enhanced Routing”. Would you like to Proceed?"
      />
      <WarningModal
        isOpen={confirmation.visible}
        onCancel={() => {
          setConfirmation(INITIAL_CONFIRMATION_STATE);
        }}
        onConfirm={onSimCheck}
        body={confirmation.bodyText}
      />
    </div>
  );
});

export default AdminTools;
